import React from 'react';
import { Home, Building, CreditCard } from 'lucide-react';

/**
 * Компонент секции дополнительных активов
 */
const AdditionalAssetsSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-green-50 dark:bg-green-900/20 p-4 rounded-lg border border-green-200 dark:border-green-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Building className="w-5 h-5 mr-2 text-green-500" />
        Дополнительные активы
      </h3>
      
      {/* Учет недвижимости */}
      <div className="mb-4">
        <label className="inline-flex items-center">
          <input
            type="checkbox"
            name="includeRealestate"
            checked={formData.includeRealestate}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <span className="ml-2 text-sm font-medium text-gray-700 dark:text-gray-300">
            Учитывать недвижимость в расчетах
          </span>
        </label>
        
        {formData.includeRealestate && (
          <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-4 pl-6 border-l-2 border-green-200 dark:border-green-800">
            <div>
              <label htmlFor="realestateValue" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
                <Home className="w-4 h-4 mr-2 text-green-500" />
                Рыночная стоимость недвижимости (₽)
              </label>
              <input
                type="text"
                id="realestateValue"
                name="realestateValue"
                value={formData.realestateValue}
                onChange={handleInputChange}
                className={`form-input w-full ${errors.realestateValue ? 'input-error' : ''}`}
                placeholder="Введите сумму"
              />
              {errors.realestateValue && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.realestateValue}
                </p>
              )}
            </div>
            
            <div>
              <label htmlFor="realestateIncome" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Доход от недвижимости (₽/мес)
              </label>
              <input
                type="text"
                id="realestateIncome"
                name="realestateIncome"
                value={formData.realestateIncome}
                onChange={handleInputChange}
                className={`form-input w-full ${errors.realestateIncome ? 'input-error' : ''}`}
                placeholder="Введите сумму"
              />
              {errors.realestateIncome && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.realestateIncome}
                </p>
              )}
            </div>
          </div>
        )}
      </div>
      
      {/* Учет НПФ */}
      <div>
        <label className="inline-flex items-center">
          <input
            type="checkbox"
            name="includeNPS"
            checked={formData.includeNPS}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <span className="ml-2 text-sm font-medium text-gray-700 dark:text-gray-300">
            Учитывать накопительную пенсию (НПФ)
          </span>
        </label>
        
        {formData.includeNPS && (
          <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-4 pl-6 border-l-2 border-green-200 dark:border-green-800">
            <div>
              <label htmlFor="npsAmount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
                <CreditCard className="w-4 h-4 mr-2 text-green-500" />
                Текущая сумма в НПФ (₽)
              </label>
              <input
                type="text"
                id="npsAmount"
                name="npsAmount"
                value={formData.npsAmount}
                onChange={handleInputChange}
                className={`form-input w-full ${errors.npsAmount ? 'input-error' : ''}`}
                placeholder="Введите сумму"
              />
              {errors.npsAmount && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.npsAmount}
                </p>
              )}
            </div>
            
            <div>
              <label htmlFor="npsContribution" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Ежемесячные отчисления в НПФ (₽)
              </label>
              <input
                type="text"
                id="npsContribution"
                name="npsContribution"
                value={formData.npsContribution}
                onChange={handleInputChange}
                className={`form-input w-full ${errors.npsContribution ? 'input-error' : ''}`}
                placeholder="Введите сумму"
              />
              {errors.npsContribution && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.npsContribution}
                </p>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Информационный блок */}
      <div className="mt-4 bg-green-100 dark:bg-green-900/30 p-3 rounded-lg border border-green-200 dark:border-green-800">
        <div className="flex items-start">
          <Building className="w-5 h-5 text-green-600 dark:text-green-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-green-700 dark:text-green-300 mb-1">
              О дополнительных активах
            </h4>
            <p className="text-xs text-green-600 dark:text-green-400">
              Добавление недвижимости и накопительной пенсии позволяет получить более полную картину вашего финансового положения и точнее рассчитать путь к финансовой независимости.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdditionalAssetsSection;